<template>
	<div  v-loading="loading" id="equitmentdetail">
		<div>
			<Header></Header>
			<!--详情-->
			<div class="detail-box">
				<div class="title">
					{{details.title}}
				</div>
				<div class="container-box">
					<div>
						<img v-if="srctab ==false" style="width:485px;height:475px;background-size:cover;background-position:50%"  :style="{backgroundImage:'url('+details.cover_img+')'}" >
						<img v-if="srctab ==1" style="width:485px;height:475px"  v-lazy="lazyImg(album[0])" >
						<img v-if="srctab ==2" style="width:485px;height:475px"  v-lazy="lazyImg(album[1])" >
						<img v-if="srctab ==3" style="width:485px;height:475px"  v-lazy="lazyImg(album[2])" >
						<img v-if="srctab ==4" style="width:485px;height:475px"  v-lazy="lazyImg(album[3])" >
						<div class="foot-img">
												<div style="width:119px;height:119px;background-size:cover;background-position:50%"  v-for="(item,index) in shop.album" v-bind:key="item.id"
							  ref="picDom" @click="pictab(index)"
							  v-if="index <= 3"
							  :class="index == 0? 'first-pictab' : 'pictab'"
							  :style="{backgroundImage:'url('+item+')'}"></div>
						</div>
					</div>
					<div class="collect-box">
						<div v-html="details.content" class="right-detail">
						</div>
						<div>
							<div v-if="details.is_favorite==1"  @click="collectShop(false)" class="collect">
								<img style="width:26px;height:27px" src="@/assets/collect.png" alt="">
								<div style="width:70px;color:#F9BE04" >取消</div>
							</div>
							<div v-else  @click="collectShop(true)" class="collect">
								<img style="width:26px;height:27px" src="@/assets/sc.png" alt="">
								<div style="width:70px;" >收藏</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="container">
				<div class="titles">
					<span>产品参数</span>
				</div>
				<div class="describe">
					<div style="margin-top:12px">{{details.description}}</div>
				</div>
			</div>

			<div class="container">
				<div class="titless">
					<div>相关帖子</div>
					<!--<div style="font-size: 14px;color: #6A6868;">更多</div>-->
				</div>
				<div class="table">
					<div class="editor">作者</div>
					<div class="reply">回复/查看</div>
				</div>
				<div style="padding-bottom:20px; min-height: 100px" v-loading="tz_loading" >
					<div v-for="item in post" v-bind:key="item.id" class="table-box">
					 <a target="_blank" style="text-decoration:none;" :href="'http://www.hd199.com/thread-' + item.tid +'-1-1.html'"><div class="discuss">{{item.subject}}</div></a>
						<div class="containers-box">
							<div style="margin-right:54px;" class="time">
								<div>{{item.author}}</div>
								<div>{{item.dateline |time}}</div>
							</div>
							<div style="margin-right:58px;" class="time">
								<div>{{item.replies}}</div>
								<div>{{item.views}}</div>
							</div>
						</div>
					</div>
					<div  style="text-align: center;font-size: 16px;	color: #555; line-height: 50px" v-show="post_visable">暂无帖子</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import {getBrandList} from '@/api/secendHands/axios'
	import {getVideoList} from '@/api/secendHands/axios'
	import {getCondition} from '@/api/secendHands/axios'
	import Foot from '@/components/common/Foot'
	import Header from '@/components/equitment/Header'
	import {BBSHOST} from '@/config/config'
	import Mixin from '@/common/js/mixin'
	export default {
		mixins: [Mixin],
		name: 'App',
		data() {
			return {
				input: '',
				value: '',
				dialogVisible: false,
				condition:[],
				brand:[],
				video:[],
				fileList:[{}],
				details:[],
				album:[],
				post:[],
				post_visable:true,
				srctab:false, //图片显示大图
				tz_loading:true,
				loading:true
			};
		},
		components:{
			Foot,
			Header,
		},
		created () {
			this.getDetail()
		},
		methods: {
			companyTypeEvent(index) {
				this.$refs.companyTypeDOM.forEach((ele, Mindex) => {
					index === Mindex ? (this.$refs.companyTypeDOM[Mindex].style.color = '#F9BE04')
						: (this.$refs.companyTypeDOM[Mindex].style.color = '#D3D3D2')

					index === Mindex ? (this.$refs.companyTypeDOM[Mindex].style.border = '1px solid #F9BE04')
						: (this.$refs.companyTypeDOM[Mindex].style.border = '1px solid #D3D3D2')
				})
			},
			pictab(index) {
				this.srctab = index + 1
				this.$refs.picDom.forEach((ele, Mindex) => {
					index === Mindex ? (this.$refs.picDom[Mindex].style.color = '#F9BE04')
						: (this.$refs.picDom[Mindex].style.color = '#D3D3D2')

					index === Mindex ? (this.$refs.picDom[Mindex].style.border = '1px solid #F9BE04')
						: (this.$refs.picDom[Mindex].style.border = '1px solid #D3D3D2')
				})
			},
			getDetail: function () {
				this.$get('/apis/depot/depot/'+this.$route.params.id, {
						params: {
						uid :getCookie("user")?getCookie("user"):getCookie("dzq_user_id"),
					}
				}).then((res)=>{
					this.details = res.data
					this.album = res.data.album
					this.loading = false
					this.post = res.data.relatedposts
					this.tz_loading=false
					if(this.post.length>0){
						this.post_visable=false
					}
				})
			},
			
			// 添加收藏 取消收藏
			collectShop (value) {
				if(value===true){
					this.$post('/apis/depot/depotFavorite',{
						user_id:getCookie("user")?getCookie("user"):getCookie("dzq_user_id"),
						goods_id:this.$route.params.id	
					}).then((res) => {
						if(res){
							this.$message({
								message:'收藏成功',
								type:'success',
								onClose:()=>{
									this.getDetail()
								}
							});
						}
					})
				}else{
					this.$_delete('/apis/depot/depotFavorite/'+this.$route.params.id+'?uid='+getCookie("user")?getCookie("user"):getCookie("dzq_user_id")).then((res)=>{
						if(res){
							this.$message({
								message:'取消收藏成功',
								type:'success',
								onClose:()=>{
									this.getDetail()
								}
							});
						}
					})
				}
			},
		}
	}
</script>

<style >
	body{
		margin: 0px;
	}
	#equitmentdetail{
		min-width: 1200px;
	}
	#equitmentdetail .titled {
		height:60px;
		width: 100%;
		background: #272727;
		display: flex;
		justify-content: space-between;
		align-items: center
	}
	.collect-box{
		display: flex;
		justify-content: space-between;
		width: 100%;
	}


	#equitmentdetail .title{
		text-align: center;
		font-size: 28px;
		color: #232323;
		margin-top: 42px;
		padding-bottom: 32px;
	}
	#equitmentdetail .title-tab{
		display: flex;
	}
	#equitmentdetail .pictab{
		border: 1px solid #fff;
	}
	#equitmentdetail .first-pictab{
		border: 1px solid #F9BE04;
	}
	#equitmentdetail .title-tab div{
		color: #fff;
		padding-left: 45px;
		font-size: 16px;
		line-height: 40px;
	}
	.collect{
		text-align: center;
		justify-content: flex-end;
		cursor: pointer;
	}
	#equitmentdetail .foot-img{
		display: flex;
		margin-top: 10px;
	}
	#equitmentdetail .vertical{
		width: 1px;
		background: #fff;
		opacity: 0.4;
		margin-left: 11px
	}
	#equitmentdetail .container-box{
		display: flex;
		justify-content: flex-start;
		box-sizing: border-box;
		width: 1200px;
		margin: auto;
	}
	#equitmentdetail .container{
		width: 1200px;
		margin: auto;
	}
	#equitmentdetail .right-detail{
		margin-left: 40px;
		height: 500px;
		overflow: hidden;
	}
	#equitmentdetail .login-me{
		color:#fff;
		font-size: 16;
		display: flex;
		margin-right: 160px；
	}
	#equitmentdetail .login-me img{
		height: 14px;
		width: 14px;
	}
	#equitmentdetail .login-me div{
		margin-right: 37px;
		display: flex;
		align-items: center
	}
	#equitmentdetail .login-me span{
		margin-left: 8px;
		margin-top: -3px;
		color: #fff;
		font-size: 14px;
	}
	.el-icon-close:before{
		color: black
	}
	.el-dialog__header{
		background: #F9BE04;
		padding: 16px 20px;
	}
	.el-textarea__inner{
		height: 150px;
	}
	#equitmentdetail .classifys{
		display: flex;
		font-size: 18px;
		color: #303030;
		margin-top: 30px;
		display: flex;
		padding-left: 35px;
		align-items: center;
	}
	#equitmentdetail .class-list{
		display: flex;
	}
	#equitmentdetail .select{
		border: 1px solid #D3D3D2;
		border-radius: 8px;
		padding: 0 12px;
		font-size: 12px;
		color: #D3D3D2;
		margin-left: 20px;
	}
	#equitmentdetail .first-select{
		border: 1px solid #F9BE04;
		border-radius: 8px;
		color: #F9BE04;
		margin-left: 20px;
		padding: 0 12px;
		font-size: 12px;
	}
	.el-checkbox__label{
		font-size: 16px;
		color: #BCBCBC;
	}
	.el-submenu{
		top:-26px !important;
	}
	.el-submenu .el-menu{
		z-index: 1;
	}
	.el-checkbox__input.is-checked+.el-checkbox__label{
		color:#F9BF07;
	}
	.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
		background: #F9BF07;
		border-color: #F9C00B;
	}
	.el-checkbox__inner:hover{
		border-color: #F9C00B;
	}
	.el-checkbox__input.is-focus.el-checkbox__inner{
		border-color: #F9C00B;
	}
	#equitmentdetail .load-button{
		background: #F9C213;
		box-shadow: 0 2px 4px 0 rgba(198,198,198,0.50);
		border-radius: 2px;
		border: none;
		color: #fff;
		width: 110px;
		height: 37px;
		margin-left: 3px;
		font-size: 18px;
	}
	.el-textarea{
		width: 80%;
	}
	.dialog-footer{
		display: flex;
		justify-content: center;
	}
	.dialog-footer button{
		border:none;
		background: #F9C213;
		box-shadow: 0 2px 4px 0 rgba(198,198,198,0.50);
		border-radius: 2px;
		height: 37px;
		width: 142px;
		color: #fff;
		font-size: 18px;
	}
	.el-submenu{
		position: absolute;
		top: -28px;
		background: #272727;
		width: 110px;
	}
	.el-menu-item.is-active{
		color: #F9C213;
	}
	.el-submenu__title:hover{
		background: #272727;
	}
	.el-submenu__title{
		padding: 0 !important;
	}
	.el-submenu .el-menu-item{
		padding: 0 !important;
		min-width: 0;
		text-align: center;
	}

	#equitmentdetail .titles{
		background: #fbfbfb;
		height: 53px;
		border-left: 5px solid #F9BE04;
		width: 100%;
		line-height: 53px;
		margin-top: 20px;
	}
	#equitmentdetail .titles span{
		font-size: 20px;
		color: #2E2E2E;
		margin-left: 18px
	}
	#equitmentdetail .describe{
		font-size: 12px;
		color: #2E2E2E;
		margin-left: 23px;
	}
	#equitmentdetail .titless{
		background: #fbfbfb;
		height: 53px;
		border-left: 5px solid #F9BE04;
		width: 100%;
		line-height: 53px;
		display: flex;
		justify-content: space-between;
		font-size: 20px;
		color: #2E2E2E;
		margin-top: 20px;
	}
	#equitmentdetail .titless div{
		margin:0 17px;
	}
	#equitmentdetail .table{
		display: flex;
		justify-content: flex-end;
		line-height: 40px;
		border-left: 1px solid  #f7f7f7;
		border-right: 1px solid  #f7f7f7;
		border-bottom: 1px solid  #f7f7f7;
		margin-right: -5px;
	}
	#equitmentdetail .table-box{
		display: flex;
		justify-content: space-between;
		line-height: 40px;
		border-left: 1px solid  #f7f7f7;
		border-right: 1px solid  #f7f7f7;
		border-bottom: 1px solid  #f7f7f7;
		margin-right: -5px;
	}
	#equitmentdetail .editor{
		margin-right: 90px;
		font-size: 12px;
		color: #9E9E9E;
	}
	#equitmentdetail .reply{
		margin-right: 39px;
		font-size: 12px;
		color: #9E9E9E;
	}
	#equitmentdetail .report{
		margin-right: 29px;
		font-size: 12px;
		color: #9E9E9E;
	}
	#equitmentdetail .time{
		font-size: 12px;
		color: #4A4A4A;
		line-height: 20px;
		text-align: center;
	}
	#equitmentdetail .containers-box{
		display: flex;
	}
	#equitmentdetail  .discuss{
		font-size: 12px;
		color: #4A4A4A;
		margin-left: 29px;
	}
	#equitmentdetail  .discuss:hover{
		color: #F9BE04;
	}
	.el-loading-spinner .path{
		stroke:#F9BE04
	}
</style>



// WEBPACK FOOTER //
// src/components/equitment/Detail.vue